import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { useState, useEffect, useRef } from "react";
import classnames from "classnames";
import Checkbox from "../Checkbox";
import "./CheckList.scss";
export var CheckList = function CheckList(a) {
  var b = a.name,
      c = a.label,
      d = void 0 === c ? "" : c,
      e = a.options,
      f = void 0 === e ? [] : e,
      g = a.value,
      h = a.color,
      i = a.showSelectAll,
      j = a.allSelectedByDefault,
      k = a.hideCheckIcon,
      l = _objectWithoutProperties(a, ["name", "label", "options", "value", "color", "showSelectAll", "allSelectedByDefault", "hideCheckIcon"]),
      m = useRef(),
      n = useState([]),
      o = _slicedToArray(n, 2),
      p = o[0],
      q = o[1],
      r = useState([]),
      s = _slicedToArray(r, 2),
      t = s[0],
      u = s[1];

  useEffect(function () {
    if (!m.current && j) {
      var a = f.map(function (a) {
        var b = a.value;
        return b;
      });
      q(a), j && u(a), m.current = !0;
    }
  }, [j, f]);
  var v = Object.assign(g || p, []);
  b || (b = d.toLowerCase());

  var w = function onChange(a, c) {
    var d = [],
        e = c.target.checked;
    if (p.length === v.length) d = [a];else {
      d = Object.assign(v, []);
      var f = v.indexOf(a),
          g = -1 < f;
      e && !g ? d.push(a) : !e && g && d.splice(f, 1);
    }
    u(d.length === p.length), "function" == typeof l.onChange && l.onChange({
      name: b,
      value: d
    }, c);
  },
      x = classnames(l.className, "checklist", _defineProperty({}, "checklist__".concat(h), h)),
      y = function selectAll(a) {
    var c = a.target.checked,
        d = c ? p : [];
    u(c), "function" == typeof l.onChange && l.onChange({
      name: b,
      value: d
    }, a);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: x
  }, i ? /*#__PURE__*/React.createElement(Checkbox, {
    id: "".concat(b, "-all"),
    onChange: y,
    checked: t,
    className: "select-all",
    label: "all"
  }) : null, f.map(function (a) {
    var c = a.label,
        d = a.value,
        e = a.icon,
        f = a.image,
        g = a.color,
        h = -1 < v.indexOf(d),
        i = d;
    return e || f || k || (e = h ? "check" : "minus"), /*#__PURE__*/React.createElement(Checkbox, {
      key: i,
      id: "ts-checkbox-".concat(b, "-").concat(i),
      name: i,
      onChange: function onChange(a) {
        return w(d, a);
      },
      checked: h,
      label: c,
      icon: e,
      image: f,
      imageStyle: {
        background: g
      }
    });
  }));
};
export var UncontrolledCheckList = function UncontrolledCheckList(a) {
  var b = useState(),
      c = _slicedToArray(b, 2),
      d = c[0],
      e = c[1],
      f = function onChange(a) {
    var b = a.value;
    return e(b);
  };

  return /*#__PURE__*/React.createElement(CheckList, Object.assign({}, a, {
    value: d,
    onChange: f
  }));
};
export default CheckList;